define('WeltPixel_CategoryPage/js/product-item',[
    'jquery',
    'underscore',
    'Magento_Customer/js/customer-data',
    'jquery/ui',
    'jquery/jquery-storageapi'
], function ($, _, customerData) {
    $.widget('psa.productItem', {
        _create: function () {
            var self = this;
            self.wishlistBtn = self.element.find('.towishlist');
            self.wishlistPopup = self.element.find('.pop-up-box');

            /* On click wishlist button */
            self.wishlistBtn.on('click', function (event) {
                if (self._isUserLoggedIn()) {
                    /* Check if user logged in - Add to wishlist */
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    self._toggleWishList(this);
                }
            });

            /* Listen for trigger for closing wish list. This is the *only* code that hides the popup */
            $(window).on('close-wishlist', function () {
                $('.wishlist-container').children().fadeOut(200).filter('.wishlist').remove();
                $('body').off('click.snb.wishlist.close');
            });

            self._checkWishListActive();
        },

        _toggleWishList: function (button) {
            var self = this;
            var remove = false;
            var wishListData = $(button).data('post');
            var formKey = $("input[name=form_key]").val();
            wishListData.data.form_key = formKey;
            window.currentProduct = $(self.element).find('.product-item-link').text().trim();

            var whishlistId = jQuery(self.element).find('.towishlist').attr('id');
            if (jQuery('.wl-' + whishlistId).hasClass('wishlisted') == true) {
                wishListData.action = window.location.origin+'/wishlist/index/remove/';
                var wishlistItemId = null;
                var wishlistCollection = JSON.parse(localStorage.getItem('mage-cache-storage')).wishlist;
                _.each(wishlistCollection.items, function(item) {
                    if (item.product_id == wishListData.data.product) {
                        wishlistItemId = item.wishlist_item_id
                    }
                });
                wishListData.data.item = wishlistItemId;
                remove = true;
            } else {
                wishListData.action = window.location.origin+'/wishlist/index/add/';
            }

            var $body = $('body');
            $body.trigger('processStart');
            $.post(wishListData.action, wishListData.data, function() {
                self.element
                    .trigger('processStop')
                    .addClass('added-to-wishlist')
                    .find('.towishlist');

                if (remove == true) {
                  self.element
                      .removeClass('added-to-wishlist')
                      .find('.towishlist')
                      .removeClass('wishlisted');
                } else {
                    self.element
                        .find('.towishlist')
                        .addClass('wishlisted');
                }

                $body.trigger('processStop');
                var storage = $.initNamespaceStorage('mage-cache-storage').localStorage;
                storage.remove('messages');
                $.cookieStorage.set('mage-messages', '');
                customerData.set('messages', {messages: ""});
                var wishlistText =  window.currentProduct;
                var wishlistHtmlMsg = '';
                if (remove) {
                    wishlistHtmlMsg = '<div class="message-success success message show"> '+wishlistText+' has been deleted from your Wish List.</div>';
                } else {
                    wishlistHtmlMsg = '<div class="message-success success message show"> '+wishlistText+' has been added to your Wish List.</div>';
                }
                $('.link.wishlist a').removeClass('empty');
                $('.page.messages').html(wishlistHtmlMsg);
                window.currentProduct = undefined;

                var messages = $.cookieStorage.get('mage-messages');
                if (!_.isEmpty(messages)) {
                    customerData.set('messages', {messages: messages});
                    $.cookieStorage.set('mage-messages', '');
                }

                var sections = ['messages', 'wishlist'];
                customerData.invalidate(sections);
                customerData.reload(sections, true);
            });
        },

        _isUserLoggedIn: function () {
            var customer = customerData.get('customer');
            return _.isString(customer().firstname);
        },

        _checkWishListActive: function () {
            var self = this;
            // get 'kemana_wishlist' section from local storage. reference module: Kemana_Wishlist
            var wishlistStorage = JSON.parse(localStorage.getItem('mage-cache-storage')).kemana_wishlist;

            var productIdValue = self.element.find('.towishlist').attr('id');

            if (!_.isEmpty(wishlistStorage) && _.isArray(wishlistStorage.items) && wishlistStorage.items.length) {
                _.each(wishlistStorage.items, function(item) {
                    if (item === productIdValue) {
                        self.element.addClass('added-to-wishlist');
                        var wishlist = document.getElementById(item);
                        wishlist.classList.add("wishlisted");
                    }
                });
            }
            customerData.set('messages', {messages: ""});
        }
    });
    return $.psa.productItem;
});

